var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card custom-card card-builder",class:_vm.active == true ? 'active' : ''},[_c('div',{staticClass:"logo",style:({
            'background-image':
                'url(' +
                require('@/assets/images/data-image/' + _vm.logo + '') +
                ')',
        })},[_c('img',{attrs:{"src":require('@/assets/images/data-image/' + _vm.logo + '')}})]),_c('h4',[_vm._v(_vm._s(_vm.name))]),(_vm.lastUpdate)?_c('p',[_vm._v(_vm._s(_vm.lastUpdate))]):_vm._e(),(_vm.totalRecord)?_c('p',[_vm._v(_vm._s(_vm.totalRecord))]):_vm._e(),(_vm.description)?_c('p',{staticClass:"caption-description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }